var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$isPlatOr(['Dy', 'Ks']))?_c('yxCategorySelect',_vm._g(_vm._b({attrs:{"platformId":_vm.platformId}},'yxCategorySelect',_vm.$attrs,false),_vm.$listeners)):_c('yxCategorySelectSecond',_vm._g(_vm._b({attrs:{"platformId":_vm.platformId}},'yxCategorySelectSecond',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }